import React from 'react';
import { INewsMedia } from '@interfaces/iresponse-news-crawler';
import { Col, Input, Select, DatePicker } from 'antd';
import { FilterBar, Button, FormItem, } from 'asumsi-components';
import { RangePickerValue } from 'antd/lib/date-picker/interface';

const { RangePicker } = DatePicker

const Search = Input.Search;

type Props = {
  onSearch: any
  isLoaderListMedia: boolean | undefined
  dataListMedia: INewsMedia[]
  onChangeSource: (value: string) => void
  onChangeStatus: (value: string) => void
  onChangeDate: (range: RangePickerValue, dateStrings: [string, string]) => void
  onManualFetch: Function
  onRefresh: Function
}

export default function (props: Props) {
  const {
    onSearch,
    isLoaderListMedia,
    dataListMedia,
    onChangeSource,
    onChangeStatus,
    onChangeDate,
    onManualFetch,
    onRefresh
  } = props;
  const { Option } = Select;

  return (
    <FilterBar>
      <Col lg={{ span: 5 }}>
        <FormItem className="max-width-100">
          <Search onSearch={onSearch} allowClear={false} placeholder="Search" />
        </FormItem>
      </Col>

      <Col lg={{ span: 7 }}>
        <FormItem className="pl-8 max-width-100">
          <RangePicker onChange={onChangeDate} />
        </FormItem>
      </Col>

      <Col lg={{ span: 3 }}>
        <FormItem className="pl-8 max-width-100">
          <Select
            showSearch
            onChange={onChangeSource}
            loading={isLoaderListMedia}
            allowClear={false}
            defaultValue="all">
            <Option value='all'>All Source</Option>
            {dataListMedia ?
              dataListMedia.map((item: any) =>
                <Option value={item.id}>{item.name}</Option>
              ) :
              null
            }

          </Select>
        </FormItem>
      </Col>

      <Col lg={{ span: 3 }}>
        <FormItem className="pl-8 max-width-100">
          <Select
            showSearch
            onChange={onChangeStatus}
            loading={false}
            allowClear={false}
            defaultValue="all">
            <Option value='all'>All Status</Option>
            <Option value='draft'>Draft</Option>
            <Option value='published'>Published</Option>
            <Option value='unpublished'>Unpublished</Option>
          </Select>
        </FormItem>
      </Col>

      <Col style={{ flex: 'auto' }}>
        <Button className="float-right" onClick={onManualFetch} type="primary" iconLeft="plus" size="medium" text="Manual Fetch" />
        <Button className="float-right m-r-10" onClick={onRefresh} type="green" iconLeft="refresh" size="medium" text="Refresh" />
      </Col>
    </FilterBar>
  );
}



// WEBPACK FOOTER //
// ./src/pages/news-crawler/libraries/filter.tsx